export default "__VITE_ASSET__d5f69cbf__"